export const centurionNetworkPageRoute =
  ':locale/travel/lounges/centurion-network';

export const culinaryCollectivePageRoute =
  ':locale/travel/lounges/centurion-network/culinary-collective';
